module.exports = __webpack_public_path__ + "img/icon_box_2_2.71637cec.png";